import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "filters-types" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "field-pointer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (filter, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: 'filter-type-' + index,
        class: _normalizeClass(["cursor-pointer", _ctx.active.value === filter.value && 'active']),
        onClick: ($event: any) => (_ctx.onChange(filter))
      }, [
        _createTextVNode(_toDisplayString(filter.label) + " ", 1),
        (filter.pointer)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3))
          : _createCommentVNode("", true)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}